module.exports = __webpack_public_path__ + "static/media/demo3.27d1afb2.png";